import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { faHomeLgAlt } from '@fortawesome/pro-regular-svg-icons/faHomeLgAlt'
import { faHomeAlt } from '@fortawesome/pro-solid-svg-icons/faHomeAlt'
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink'
import { faExternalLink as faExternalSolidLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink'
import { faCubes as faCubesSolid } from '@fortawesome/pro-solid-svg-icons/faCubes'
import { faSitemap } from '@fortawesome/pro-regular-svg-icons/faSitemap'
import { faSitemap as faSitemapSolid } from '@fortawesome/pro-solid-svg-icons/faSitemap'
import { faBagsShopping } from '@fortawesome/pro-solid-svg-icons/faBagsShopping'
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers'
import { faUsers as faUsersSolid } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faMegaphone } from '@fortawesome/pro-regular-svg-icons/faMegaphone'
import { faMegaphone as faMegaphoneSolid } from '@fortawesome/pro-solid-svg-icons/faMegaphone'
import { faUserChart } from '@fortawesome/pro-regular-svg-icons/faUserChart'
import { faUserChart as faUserChartSolid } from '@fortawesome/pro-solid-svg-icons/faUserChart'
import { faFolders as faFoldersSolid } from '@fortawesome/pro-solid-svg-icons/faFolders'
import { faFolders as faFoldersRegular } from '@fortawesome/pro-regular-svg-icons/faFolders'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { faClock as faClockSolid } from '@fortawesome/pro-solid-svg-icons/faClock'
import { faUsersGear } from '@fortawesome/pro-regular-svg-icons/faUsersGear'
import { faUsersGear as faUsersGearSolid } from '@fortawesome/pro-solid-svg-icons/faUsersGear'
import { faLighthouse } from '@fortawesome/pro-regular-svg-icons/faLighthouse'
import { faLighthouse as faLighthouseSolid } from '@fortawesome/pro-solid-svg-icons/faLighthouse'
import { faBuildingCircleXmark } from '@fortawesome/pro-regular-svg-icons/faBuildingCircleXmark'
import { faBuildingCircleXmark as faBuildingCircleXmarkSolid } from '@fortawesome/pro-solid-svg-icons/faBuildingCircleXmark'
import { faFileShield } from '@fortawesome/pro-regular-svg-icons/faFileShield'
import { faFileShield as faFileShieldSolid } from '@fortawesome/pro-solid-svg-icons/faFileShield'

import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { isRouteAllowed, reverse } from 'src/routes/config'
import withUserData from 'src/HOCs/withUserData'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import withTranslations from 'src/HOCs/withTranslations'
import {
    hasDebugMenu,
    isAllowed,
    AZURE_INSIGHTS_USE,
    AZURE_INSIGHTS_DASHBOARDS_PERMISSION,
    WORKFLOWS_WEBUI_LOGIN,
    DASHBOARDS_HOMEPAGE_V2,
    isAnyAllowed,
    SECURITY_MENU_PERMISSIONS,
    SECURITY_ACTION_EXCEPTION_USE,
    SECURITY_ADMIN_VM_RECLASSIFICATION,
    SECURITY_COVERAGE_PERMISSIONS,
    CSAF_MENU_PERMISSIONS,
    ADMIN_VIEW_PERMISSIONS,
} from 'src/utils/permissions'
import ServicePortfolioMenu from 'src/components/Menu/menus/ServicePortfolioMenu'
import SupportCenterMenu from 'src/components/Menu/menus/SupportCenterMenu'
import CostControlMenu from 'src/components/Menu/menus/CostControlMenu'
import HealthMenu from 'src/components/Menu/menus/HealthMenu'
import InventoryMenu from 'src/components/Menu/menus/InventoryMenu'
import PlaybookMenu from 'src/components/Menu/menus/PlaybookMenu'
import ItpMenu from 'src/components/Menu/menus/ItpMenu'
import SecurityMenu from 'src/components/Menu/menus/SecurityMenu'
import ExampleMenu from 'src/components/Menu/menus/ExampleMenu'
import DebugMenu from 'src/components/Menu/menus/DebugMenu'

import TaskCenterMenu from 'src/components/Menu/menus/TaskCenterMenu'
import ExpensesMenu from 'src/components/Menu/menus/ExpensesMenu'
import SupportWorkspaceMenu from 'src/components/Menu/menus/SupportWorkspaceMenu'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
// Style
import menuStyles from './menu.module.scss'

const adminUrl = getEnvVariableValue(VARIABLES.ADMIN_URL)

const initialState = {
    exampleMfeIsOpen: false,
    dashboardsIsOpen: false,
    inventoryIsOpen: false,
    supportCenterIsOpen: false,
    servicePortfolioIsOpen: false,
    securityIsOpen: false,
    healthIsOpen: false,
    playbookIsOpen: false,
    itpIsOpen: false,
    kubeportIsOpen: false,
    digitalWorkplaceIsOpen: false,
    contactSearchIsOpen: false,
    documentsIsOpen: false,
    supportWorkspaceIsOpen: false,
    azureInsightsIsOpen: false,
}

class MainMenu extends Component {
    static propTypes = {
        /** Defines whether the entire sidebar menu is collapsed or not. */
        parentIsCollapsed: PropTypes.bool,
    }

    state = { ...initialState }

    handleDocumentClick = e => {
        this.setState({
            ...initialState,
        })
    }

    toggleMenuItem = menuItem => e => {
        e?.stopPropagation()
        const key = `${menuItem}IsOpen`
        if (this.props.parentIsCollapsed) {
            this.setState({ ...initialState, [key]: !this.state[key] })
            document.addEventListener('click', this.handleDocumentClick, {
                once: true,
            })
        } else {
            this.setState({ [key]: !this.state[key] })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.parentIsCollapsed !== this.props.parentIsCollapsed) {
            this.setState({ ...initialState })
            if (prevProps.parentIsCollapsed) {
                document.removeEventListener('click', this.handleDocumentClick)
            }
        }
    }

    renderHealthMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { healthIsOpen } = this.state
        if (
            isRouteAllowed(userData, 'health') ||
            isRouteAllowed(userData, 'runbook') ||
            isRouteAllowed(userData, 'mon')
        ) {
            return (
                <HealthMenu
                    isOpen={healthIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                    onClick={this.toggleMenuItem('health')}
                />
            )
        }

        return null
    }

    renderInventoryMenu() {
        const { parentIsCollapsed, userData } = this.props
        const { inventoryIsOpen } = this.state
        if (
            isRouteAllowed(userData, 'devices') ||
            isRouteAllowed(userData, 'capacity') ||
            isRouteAllowed(userData, 'sam')
        ) {
            return (
                <InventoryMenu
                    isOpen={inventoryIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                    onClick={this.toggleMenuItem('inventory')}
                />
            )
        }

        return null
    }

    renderAdminMenu() {
        const { t, userData, parentIsCollapsed } = this.props
        return (
            isAllowed(userData, ADMIN_VIEW_PERMISSIONS) && (
                <MainMenuItem
                    icon={faExternalLink}
                    iconActive={faExternalSolidLink}
                    title={t('Admin')}
                    to={{ pathname: `${adminUrl}` }}
                    externalLink
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        )
    }

    renderSecurityMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { securityIsOpen } = this.state

        if (
            isAnyAllowed(userData, [
                ...SECURITY_MENU_PERMISSIONS,
                ...SECURITY_COVERAGE_PERMISSIONS,
                ...CSAF_MENU_PERMISSIONS,
                SECURITY_ACTION_EXCEPTION_USE,
                SECURITY_ADMIN_VM_RECLASSIFICATION,
            ])
        ) {
            return (
                <SecurityMenu
                    isOpen={securityIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                    onClick={this.toggleMenuItem('security')}
                />
            )
        }

        return null
    }

    renderAzureInsidesMenu() {
        const { t, userData, parentIsCollapsed } = this.props
        const { azureInsightsIsOpen } = this.state
        if (!isAllowed(userData, AZURE_INSIGHTS_USE)) {
            return null
        }

        if (
            isFeatureEnabled(FEATURES.AZURE_INSIGHTS_DASHBOARD) &&
            isAllowed(userData, AZURE_INSIGHTS_DASHBOARDS_PERMISSION)
        ) {
            return (
                <MainMenuItem
                    icon={faLighthouse}
                    iconActive={faLighthouseSolid}
                    title={t('Azure Insights')}
                    isOpen={azureInsightsIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                    to={reverse('azure-insights')}
                    onClick={this.toggleMenuItem('azureInsights')}
                />
            )
        }

        return (
            <MainMenuItem
                icon={faExternalLink}
                iconActive={faExternalSolidLink}
                title={t('Azure Insights')}
                to={{
                    pathname: `https://insights.theblueocean.cloud/`,
                }}
                externalLink
                parentIsCollapsed={parentIsCollapsed}
            />
        )
    }

    renderOrdersMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { servicePortfolioIsOpen } = this.state
        if (
            isRouteAllowed(userData, 'orders') ||
            isAllowed(userData, WORKFLOWS_WEBUI_LOGIN)
        ) {
            return (
                <ServicePortfolioMenu
                    parentIsCollapsed={parentIsCollapsed}
                    isOpen={servicePortfolioIsOpen}
                    onClick={this.toggleMenuItem('servicePortfolio')}
                />
            )
        }
        return null
    }

    renderSupportCenterMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { supportCenterIsOpen } = this.state
        if (
            !(
                isRouteAllowed(userData, 'support-center') ||
                isRouteAllowed(userData, 'governance-roles') ||
                isRouteAllowed(userData, 'documents') ||
                isRouteAllowed(userData, 'tickets') ||
                isRouteAllowed(userData, 'changes')
            )
        ) {
            return null
        }

        return (
            <SupportCenterMenu
                isOpen={supportCenterIsOpen}
                parentIsCollapsed={parentIsCollapsed}
                onClick={this.toggleMenuItem('supportCenter')}
            />
        )
    }

    renderCcfMenu() {
        const { userData, parentIsCollapsed, t } = this.props

        if (isRouteAllowed(userData, 'ccf')) {
            return (
                <MainMenuItem
                    title={t('Continuous control framework')}
                    to={reverse('ccf')}
                    icon={faFileShield}
                    iconActive={faFileShieldSolid}
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        }
        return null
    }

    renderDashboardMenu() {
        const { t, userData, parentIsCollapsed } = this.props

        if (isRouteAllowed(userData, 'dashboards-discovery')) {
            return (
                <MainMenuItem
                    icon={faUserChart}
                    iconActive={faUserChartSolid}
                    title={t('Dashboards')}
                    to={reverse('dashboards-discovery')}
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        }

        return null
    }

    renderDocumentsMenu() {
        const { t, userData, parentIsCollapsed } = this.props
        const { documentsIsOpen } = this.state

        if (isRouteAllowed(userData, 'documents')) {
            return (
                <MainMenuItem
                    icon={faFoldersRegular}
                    iconActive={faFoldersSolid}
                    title={t('Documents')}
                    to={reverse('documents')}
                    isOpen={documentsIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        }

        return null
    }

    renderKubeportMenu() {
        const { userData, t, parentIsCollapsed } = this.props
        const { kubeportIsOpen } = this.state

        return isRouteAllowed(userData, 'dashboards-kubeport') ? (
            <MainMenuItem
                title={t('Cloud-Native Platform')}
                to={reverse('dashboards-kubeport')}
                icon={faCubesSolid}
                iconActive={faCubesSolid}
                isOpen={kubeportIsOpen}
                parentIsCollapsed={parentIsCollapsed}
                onClick={() =>
                    this.setState({
                        kubeportIsOpen: !kubeportIsOpen,
                    })
                }
            />
        ) : null
    }

    renderDigitalWorkplaceMenu() {
        const { userData, t, parentIsCollapsed } = this.props
        const { digitalWorkplaceIsOpen } = this.state

        return isRouteAllowed(userData, 'digital-workplace') ? (
            <MainMenuItem
                title={t('Digital workplace')}
                to={reverse('digital-workplace')}
                icon={faSitemap}
                iconActive={faSitemapSolid}
                isOpen={digitalWorkplaceIsOpen}
                parentIsCollapsed={parentIsCollapsed}
                onClick={() =>
                    this.setState({
                        digitalWorkplaceIsOpen: !digitalWorkplaceIsOpen,
                    })
                }
            />
        ) : null
    }

    renderExampleMfeMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { exampleMfeIsOpen } = this.state

        if (!isRouteAllowed(userData, 'example-mfe')) {
            return null
        }

        return (
            <ExampleMenu
                isOpen={exampleMfeIsOpen}
                onClick={this.toggleMenuItem('exampleMfe')}
                parentIsCollapsed={parentIsCollapsed}
            />
        )
    }

    renderDebugMenu() {
        const { parentIsCollapsed, userData } = this.props

        if (!hasDebugMenu(userData)) {
            return null
        }
        return <DebugMenu parentIsCollapsed={parentIsCollapsed} />
    }

    renderPlaybookMenu() {
        const { parentIsCollapsed } = this.props
        const { playbookIsOpen } = this.state
        if (!isFeatureEnabled(FEATURES.PLAYBOOK_MENU_OPTION)) {
            return null
        }
        return (
            <PlaybookMenu
                parentIsCollapsed={parentIsCollapsed}
                isOpen={playbookIsOpen}
                onClick={this.toggleMenuItem('playbook')}
            />
        )
    }

    renderCostControlMenu() {
        const { userData, parentIsCollapsed } = this.props
        if (isRouteAllowed(userData, 'cost-control')) {
            return <CostControlMenu parentIsCollapsed={parentIsCollapsed} />
        }

        return null
    }

    renderTaskCenterMenu() {
        const { userData, parentIsCollapsed } = this.props

        if (isRouteAllowed(userData, 'task-center')) {
            return <TaskCenterMenu parentIsCollapsed={parentIsCollapsed} />
        }
        return null
    }

    renderExpensesMenu() {
        const { userData, parentIsCollapsed } = this.props

        if (isRouteAllowed(userData, 'expenses')) {
            return <ExpensesMenu parentIsCollapsed={parentIsCollapsed} />
        }
        return null
    }

    renderItpMenu() {
        const { parentIsCollapsed, userData } = this.props
        const { itpIsOpen } = this.state

        if (
            isFeatureEnabled(FEATURES.ITP_MENU_OPTION) &&
            isRouteAllowed(userData, 'itp')
        ) {
            return (
                <ItpMenu
                    isOpen={itpIsOpen}
                    parentIsCollapsed={parentIsCollapsed}
                    onClick={this.toggleMenuItem('itp')}
                />
            )
        }
        return null
    }

    renderContactSearchMenu() {
        const { userData, t, parentIsCollapsed } = this.props
        const { contactSearchIsOpen } = this.state

        return isRouteAllowed(userData, 'contact-search') ? (
            <MainMenuItem
                title={t('Company contacts')}
                to={reverse('contact-search')}
                icon={faUsers}
                iconActive={faUsersSolid}
                isOpen={contactSearchIsOpen}
                parentIsCollapsed={parentIsCollapsed}
                onClick={() =>
                    this.setState({
                        contactSearchIsOpen: !contactSearchIsOpen,
                    })
                }
            />
        ) : null
    }

    renderIncidentManagerMenu() {
        const { userData, parentIsCollapsed, t } = this.props

        if (isRouteAllowed(userData, 'incident-manager')) {
            return (
                <MainMenuItem
                    title={t('Incident manager')}
                    to={reverse('incident-manager')}
                    icon={faMegaphone}
                    iconActive={faMegaphoneSolid}
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        }
        return null
    }

    renderERPMenu() {
        const { userData, t } = this.props

        if (isRouteAllowed(userData, 'erp-portal')) {
            return (
                <MainMenuItem
                    title={t('ERP Portal')}
                    to={reverse('erp-timesheets')}
                    icon={faClock}
                    iconActive={faClockSolid}
                />
            )
        }

        return null
    }

    renderAbsenceMenu() {
        const { userData, t } = this.props

        if (isRouteAllowed(userData, 'erp-absences')) {
            return (
                <MainMenuItem
                    title={t('Absences')}
                    to={reverse('erp-absences')}
                    icon={faBuildingCircleXmark}
                    iconActive={faBuildingCircleXmarkSolid}
                />
            )
        }
        return null
    }

    renderProcurementMenu() {
        const { userData, parentIsCollapsed, t } = this.props

        if (isRouteAllowed(userData, 'erp-procurement')) {
            return (
                <MainMenuItem
                    title={t('Procurement')}
                    to={reverse('erp-procurement')}
                    icon={faBagsShopping}
                    iconActive={faBagsShopping}
                    parentIsCollapsed={parentIsCollapsed}
                />
            )
        }
        return null
    }

    renderTeamManagementMenu() {
        const { userData, parentIsCollapsed, t } = this.props

        if (isRouteAllowed(userData, 'team-management')) {
            return (
                <>
                    <hr />
                    <MainMenuItem
                        title={t('Team management')}
                        to={reverse('team-management')}
                        icon={faUsersGear}
                        iconActive={faUsersGearSolid}
                        parentIsCollapsed={parentIsCollapsed}
                    />
                </>
            )
        }
        return null
    }

    renderSupportWorkspaceMenu() {
        const { userData, parentIsCollapsed } = this.props
        const { supportWorkspaceIsOpen } = this.state
        if (
            isRouteAllowed(userData, 'support-workspace-tickets') ||
            isRouteAllowed(userData, 'support-workspace-changes')
        ) {
            return (
                <SupportWorkspaceMenu
                    parentIsCollapsed={parentIsCollapsed}
                    isOpen={supportWorkspaceIsOpen}
                    onClick={this.toggleMenuItem('supportWorkspace')}
                />
            )
        }
        return null
    }

    render() {
        const { t, parentIsCollapsed } = this.props

        return (
            <nav className={menuStyles.main}>
                <MainMenuItem
                    icon={faHomeLgAlt}
                    iconActive={faHomeAlt}
                    title={t('Home')}
                    to={
                        isAllowed(this.props.userData, DASHBOARDS_HOMEPAGE_V2)
                            ? reverse('home')
                            : reverse('dashboard')
                    }
                    parentIsCollapsed={parentIsCollapsed}
                    exact={true}
                />
                {this.renderAdminMenu()}
                {this.renderERPMenu()}
                {this.renderAbsenceMenu()}
                {this.renderTaskCenterMenu()}
                {this.renderExpensesMenu()}
                {this.renderHealthMenu()}
                {this.renderInventoryMenu()}
                {this.renderSecurityMenu()}
                {this.renderCostControlMenu()}
                {this.renderOrdersMenu()}
                {this.renderSupportCenterMenu()}
                {this.renderCcfMenu()}
                {this.renderDocumentsMenu()}
                {this.renderAzureInsidesMenu()}
                {this.renderDashboardMenu()}
                {this.renderSupportWorkspaceMenu()}
                {this.renderContactSearchMenu()}
                {this.renderExampleMfeMenu()}
                {this.renderDigitalWorkplaceMenu()}
                {this.renderPlaybookMenu()}
                {this.renderItpMenu()}
                {this.renderKubeportMenu()}
                {this.renderIncidentManagerMenu()}
                {this.renderDebugMenu()}
                {this.renderProcurementMenu()}
                {this.renderTeamManagementMenu()}
            </nav>
        )
    }
}

export default withTranslations('MainMenu', 'MainMenu')(withUserData(MainMenu))
